import { NativeModules, Linking } from "react-native";

const _openDeepLink = async (url) => {
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    } else {
      console.error(`DeepLink not supported: ${url}`)
    }
};

NativeModules.GenericModule = {
  openDeepLink: _openDeepLink,
};
